import React from 'react'
import Box from '@material-ui/core/Box'
import AdminReportDepositStatisticForm from '../../../components/admin/adminReport/AdminReportDepositStatisticForm'
import AdminReportDepositStatisticTable from '../../../components/admin/adminReport/AdminReportDepositStatisticTable'

const AdminReportDepositStatisticPage: React.FC = () => {
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <AdminReportDepositStatisticForm />
      </Box>
      <Box paddingTop={3}>
        <AdminReportDepositStatisticTable />
      </Box>
    </Box>
  )
}

export default React.memo(AdminReportDepositStatisticPage)
